import { ApiStudentRequest, request } from '../utils/request'
import { useQuery } from '@tanstack/react-query'

export type RawSpaConfigResponse = {
  auth: {
    issuer: string
    clientId: string
    redirectUri: string
  }
  monitorConfig?: {
    config: {
      guestRoleArn: string
      identityPoolId: string
    }
    appMonitorId: string
    region: string
  }
  school: {
    name: string
  }
  ui: {
    headerLogo: {
      '138x36': string
    }
    signupLogo: {
      '300x78': string
    }
    signupBackgroundColour: string
    crystalTheme: {
      colors: {
        primary: string
        secondary: string
        positive: string
        warning: string
        negative: string
        magic: string
      }
    }
    favicon: string
  }
  policy: {
    privacyPolicy: {
      id: string
      url: string
      policyVersion: string
      createdAt: string
    }
    termsOfUse?: {
      id: string
      url: string
      policyVersion: string
      createdAt: string
    }
  }
}

type SpaConfig = {
  isLoading: boolean
  config: {
    issuer: string
    clientId: string
    redirectUri: string
  } | null
  monitorConfig?: {
    config: {
      guestRoleArn: string
      identityPoolId: string
    }
    appMonitorId: string
    region: string
  }
  school: {
    name: string
  }
  ui: {
    headerLogo: {
      '138x36': string
    }
    signupLogo: {
      '300x78': string
    }
    signupBackgroundColour: string
    crystalTheme: {
      colors: {
        primary: string
        secondary: string
        positive: string
        warning: string
        negative: string
        magic: string
      }
    }
    favicon: string
  } | null
  policy: {
    privacyPolicy: {
      id: string
      url: string
      policyVersion: string
      createdAt: string
    }
    termsOfUse?: {
      id: string
      url: string
      policyVersion: string
      createdAt: string
    }
  }
}

export function useGetSpaConfig(): SpaConfig {
  const { isLoading, data } = useQuery({
    queryKey: ['spaConfig'],
    queryFn: async () => {
      const response = await request<RawSpaConfigResponse>(
        new ApiStudentRequest(`/spa-config`, { method: 'GET' }),
        {
          isExpectedResponse: (res): res is RawSpaConfigResponse => res as boolean,
        },
      )
      return response
    },
    enabled: true,
    refetchOnWindowFocus: false,
    retry: false,
  })

  return {
    isLoading: isLoading,
    config: data?.auth ?? null,
    monitorConfig: data?.monitorConfig ?? undefined,
    ui: data?.ui ?? null,
    school: data?.school ?? { name: '' },
    policy: data?.policy ?? {
      privacyPolicy: { id: '', url: '', policyVersion: '1', createdAt: '' },
      termsOfUse: undefined,
    },
  }
}
